/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
var __webpack_exports__ = {};

;// CONCATENATED MODULE: ./node_modules/slidetoggle/dist/utils/Numbers.js
var Numbers;
(function (Numbers) {
    Numbers.parseOrElse = function (str, or) {
        if (or === void 0) { or = '0'; }
        if (str) {
            return parseInt(str);
        }
        return or && typeof or === 'string' ? parseInt(or) : 0;
    };
})(Numbers || (Numbers = {}));
//# sourceMappingURL=Numbers.js.map
;// CONCATENATED MODULE: ./node_modules/slidetoggle/dist/utils/Element.js

var Element_Element;
(function (Element) {
    var isElement = function (element) { return element instanceof HTMLElement; };
    Element.setStyles = function (element, styles) {
        Object.keys(styles).map(function (key) {
            element.style[key] = styles[key];
        });
    };
    Element.getBoxStyles = function (element) {
        var computedValue = window.getComputedStyle(element);
        return {
            height: Numbers.parseOrElse(computedValue.height),
            padding: {
                top: Numbers.parseOrElse(computedValue.paddingTop),
                bottom: Numbers.parseOrElse(computedValue.paddingBottom),
            },
            border: {
                top: Numbers.parseOrElse(computedValue.borderTopWidth),
                bottom: Numbers.parseOrElse(computedValue.borderBottomWidth),
            },
        };
    };
    Element.getElement = function (element) {
        if (isElement(element)) {
            return element;
        }
        var elementFromSelector = document.querySelector(element);
        if (isElement(elementFromSelector)) {
            return elementFromSelector;
        }
        throw new Error('Your element does not exist in the DOM.');
    };
    Element.setAttribute = function (element, attribute, value) {
        element.setAttribute(attribute, value);
    };
    Element.getAttribute = function (element, attribute) {
        return element.getAttribute(attribute);
    };
})(Element_Element || (Element_Element = {}));
//# sourceMappingURL=Element.js.map
;// CONCATENATED MODULE: ./node_modules/slidetoggle/dist/utils/Event.js
var Events;
(function (Events) {
    Events.on = function (element, event, callback) {
        element.addEventListener(event, callback);
        return {
            destroy: function () { return element && element.removeEventListener(event, callback); },
        };
    };
})(Events || (Events = {}));
//# sourceMappingURL=Event.js.map
;// CONCATENATED MODULE: ./node_modules/slidetoggle/dist/utils/Animate.js
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


var Animate;
(function (Animate) {
    var slideToggleAttribute = 'data-slide-toggle';
    var onRequestAnimationFrame = function (callback) {
        requestAnimationFrame(callback);
    };
    var getTransition = function (options) {
        var _a = options.miliseconds, miliseconds = _a === void 0 ? 200 : _a, _b = options.transitionFunction, transitionFunction = _b === void 0 ? 'linear' : _b;
        return "all " + miliseconds + "ms " + transitionFunction + " 0s";
    };
    var isHidden = function (element) { return Element_Element.getAttribute(element, slideToggleAttribute) === 'false'; };
    var isShown = function (element) { return Element_Element.getAttribute(element, slideToggleAttribute) === 'true'; };
    Animate.shouldCollapse = function (element) {
        var attribute = Element_Element.getAttribute(element, slideToggleAttribute);
        if (!attribute) {
            var height = Element_Element.getBoxStyles(element).height;
            return height && height > 0;
        }
        return Element_Element.getAttribute(element, slideToggleAttribute) === 'true';
    };
    Animate.hide = function (element, options) {
        var _a;
        if (isHidden(element)) {
            return;
        }
        (_a = options.onAnimationStart) === null || _a === void 0 ? void 0 : _a.call(options);
        var _b = Element_Element.getBoxStyles(element), height = _b.height, boxStyles = __rest(_b, ["height"]);
        Element_Element.setStyles(element, { transition: '' });
        onRequestAnimationFrame(function () {
            Element_Element.setStyles(element, {
                overflow: 'hidden',
                height: height + "px",
                paddingTop: boxStyles.padding.top + "px",
                paddingBottom: boxStyles.padding.bottom + "px",
                borderTopWidth: boxStyles.border.top + "px",
                borderBottomWidth: boxStyles.border.bottom + "px",
                transition: getTransition(options),
            });
            onRequestAnimationFrame(function () {
                Element_Element.setStyles(element, {
                    height: '0',
                    paddingTop: '0',
                    paddingBottom: '0',
                    borderTopWidth: '0',
                    borderBottomWidth: '0',
                });
                var event = Events.on(element, 'transitionend', function () {
                    var _a;
                    event.destroy();
                    (_a = options.onAnimationEnd) === null || _a === void 0 ? void 0 : _a.call(options);
                });
            });
        });
        Element_Element.setAttribute(element, slideToggleAttribute, 'false');
    };
    Animate.show = function (element, options) {
        var _a;
        if (isShown(element)) {
            return;
        }
        var _b = options.elementDisplayStyle, elementDisplayStyle = _b === void 0 ? 'block' : _b;
        (_a = options.onAnimationStart) === null || _a === void 0 ? void 0 : _a.call(options);
        Element_Element.setStyles(element, {
            transition: '',
            display: elementDisplayStyle,
            height: 'auto',
            paddingTop: '',
            paddingBottom: '',
            borderTopWidth: '',
            borderBottomWidth: '',
        });
        var _c = Element_Element.getBoxStyles(element), height = _c.height, boxStyles = __rest(_c, ["height"]);
        Element_Element.setStyles(element, {
            display: 'none',
        });
        onRequestAnimationFrame(function () {
            Element_Element.setStyles(element, {
                display: elementDisplayStyle,
                overflow: 'hidden',
                height: '0',
                paddingTop: '0',
                paddingBottom: '0',
                borderTopWidth: '0',
                borderBottomWidth: '0',
                transition: getTransition(options),
            });
            onRequestAnimationFrame(function () {
                Element_Element.setStyles(element, {
                    height: height + "px",
                    paddingTop: boxStyles.padding.top + "px",
                    paddingBottom: boxStyles.padding.bottom + "px",
                    borderTopWidth: boxStyles.border.top + "px",
                    borderBottomWidth: boxStyles.border.bottom + "px",
                });
                var event = Events.on(element, 'transitionend', function () {
                    var _a;
                    Element_Element.setStyles(element, {
                        height: '',
                        overflow: '',
                        paddingTop: '',
                        paddingBottom: '',
                        borderTopWidth: '',
                        borderBottomWidth: '',
                    });
                    event.destroy();
                    (_a = options.onAnimationEnd) === null || _a === void 0 ? void 0 : _a.call(options);
                });
            });
        });
        Element_Element.setAttribute(element, slideToggleAttribute, 'true');
    };
})(Animate || (Animate = {}));
//# sourceMappingURL=Animate.js.map
;// CONCATENATED MODULE: ./node_modules/slidetoggle/dist/utils/index.js


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/slidetoggle/dist/common/hide.js

var Hide;
(function (Hide) {
    Hide.on = function (element, options) {
        Animate.hide(element, options);
    };
})(Hide || (Hide = {}));
var hide = function (element, options) {
    Hide.on(Element_Element.getElement(element), options);
};
//# sourceMappingURL=hide.js.map
;// CONCATENATED MODULE: ./node_modules/slidetoggle/dist/common/show.js

var Show;
(function (Show) {
    Show.on = function (element, options) {
        Animate.show(element, options);
    };
})(Show || (Show = {}));
var show = function (element, options) {
    Show.on(Element_Element.getElement(element), options);
};
//# sourceMappingURL=show.js.map
;// CONCATENATED MODULE: ./node_modules/slidetoggle/dist/common/toggle.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var Toggle;
(function (Toggle) {
    var onHideEnd = function (options) {
        return function () {
            var _a, _b;
            (_a = options.onClose) === null || _a === void 0 ? void 0 : _a.call(options);
            (_b = options.onAnimationEnd) === null || _b === void 0 ? void 0 : _b.call(options);
        };
    };
    var onShowEnd = function (options) {
        return function () {
            var _a, _b;
            (_a = options.onOpen) === null || _a === void 0 ? void 0 : _a.call(options);
            (_b = options.onAnimationEnd) === null || _b === void 0 ? void 0 : _b.call(options);
        };
    };
    Toggle.on = function (element, options) {
        if (Animate.shouldCollapse(element)) {
            Animate.hide(element, __assign(__assign({}, options), { onAnimationEnd: onHideEnd(options) }));
        }
        else {
            Animate.show(element, __assign(__assign({}, options), { onAnimationEnd: onShowEnd(options) }));
        }
    };
})(Toggle || (Toggle = {}));
var toggle = function (element, options) {
    Toggle.on(Element_Element.getElement(element), options);
};
//# sourceMappingURL=toggle.js.map
;// CONCATENATED MODULE: ./node_modules/slidetoggle/dist/common/index.js



//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/slidetoggle/dist/index.js

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/tabbable/dist/index.esm.js
/*!
* tabbable 5.2.1
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var candidateSelectors = ['input', 'select', 'textarea', 'a[href]', 'button', '[tabindex]', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])', 'details>summary:first-of-type', 'details'];
var candidateSelector = /* #__PURE__ */candidateSelectors.join(',');
var matches = typeof Element === 'undefined' ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;

var getCandidates = function getCandidates(el, includeContainer, filter) {
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));

  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }

  candidates = candidates.filter(filter);
  return candidates;
};

var isContentEditable = function isContentEditable(node) {
  return node.contentEditable === 'true';
};

var getTabindex = function getTabindex(node) {
  var tabindexAttr = parseInt(node.getAttribute('tabindex'), 10);

  if (!isNaN(tabindexAttr)) {
    return tabindexAttr;
  } // Browsers do not return `tabIndex` correctly for contentEditable nodes;
  // so if they don't have a tabindex attribute specifically set, assume it's 0.


  if (isContentEditable(node)) {
    return 0;
  } // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
  //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
  //  yet they are still part of the regular tab order; in FF, they get a default
  //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
  //  order, consider their tab index to be 0.


  if ((node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) {
    return 0;
  }

  return node.tabIndex;
};

var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};

var isInput = function isInput(node) {
  return node.tagName === 'INPUT';
};

var isHiddenInput = function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
};

var isDetailsWithSummary = function isDetailsWithSummary(node) {
  var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function (child) {
    return child.tagName === 'SUMMARY';
  });
  return r;
};

var getCheckedRadio = function getCheckedRadio(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};

var isTabbableRadio = function isTabbableRadio(node) {
  if (!node.name) {
    return true;
  }

  var radioScope = node.form || node.ownerDocument;

  var queryRadios = function queryRadios(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };

  var radioSet;

  if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
      return false;
    }
  }

  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};

var isRadio = function isRadio(node) {
  return isInput(node) && node.type === 'radio';
};

var isNonTabbableRadio = function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
};

var isHidden = function isHidden(node, displayCheck) {
  if (getComputedStyle(node).visibility === 'hidden') {
    return true;
  }

  var isDirectSummary = matches.call(node, 'details>summary:first-of-type');
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;

  if (matches.call(nodeUnderDetails, 'details:not([open]) *')) {
    return true;
  }

  if (!displayCheck || displayCheck === 'full') {
    while (node) {
      if (getComputedStyle(node).display === 'none') {
        return true;
      }

      node = node.parentElement;
    }
  } else if (displayCheck === 'non-zero-area') {
    var _node$getBoundingClie = node.getBoundingClientRect(),
        width = _node$getBoundingClie.width,
        height = _node$getBoundingClie.height;

    return width === 0 && height === 0;
  }

  return false;
}; // form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset


var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
  if (isInput(node) || node.tagName === 'SELECT' || node.tagName === 'TEXTAREA' || node.tagName === 'BUTTON') {
    var parentNode = node.parentElement;

    while (parentNode) {
      if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
        // look for the first <legend> as an immediate child of the disabled
        //  <fieldset>: if the node is in that legend, it'll be enabled even
        //  though the fieldset is disabled; otherwise, the node is in a
        //  secondary/subsequent legend, or somewhere else within the fieldset
        //  (however deep nested) and it'll be disabled
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i);

          if (child.tagName === 'LEGEND') {
            if (child.contains(node)) {
              return false;
            } // the node isn't in the first legend (in doc order), so no matter
            //  where it is now, it'll be disabled


            return true;
          }
        } // the node isn't in a legend, so no matter where it is now, it'll be disabled


        return true;
      }

      parentNode = parentNode.parentElement;
    }
  } // else, node's tabbable/focusable state should not be affected by a fieldset's
  //  enabled/disabled state


  return false;
};

var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
  if (node.disabled || isHiddenInput(node) || isHidden(node, options.displayCheck) || // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }

  return true;
};

var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
  if (!isNodeMatchingSelectorFocusable(options, node) || isNonTabbableRadio(node) || getTabindex(node) < 0) {
    return false;
  }

  return true;
};

var tabbable = function tabbable(el, options) {
  options = options || {};
  var regularTabbables = [];
  var orderedTabbables = [];
  var candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  candidates.forEach(function (candidate, i) {
    var candidateTabindex = getTabindex(candidate);

    if (candidateTabindex === 0) {
      regularTabbables.push(candidate);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        node: candidate
      });
    }
  });
  var tabbableNodes = orderedTabbables.sort(sortOrderedTabbables).map(function (a) {
    return a.node;
  }).concat(regularTabbables);
  return tabbableNodes;
};

var focusable = function focusable(el, options) {
  options = options || {};
  var candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
  return candidates;
};

var isTabbable = function isTabbable(node, options) {
  options = options || {};

  if (!node) {
    throw new Error('No node provided');
  }

  if (matches.call(node, candidateSelector) === false) {
    return false;
  }

  return isNodeMatchingSelectorTabbable(options, node);
};

var focusableCandidateSelector = /* #__PURE__ */candidateSelectors.concat('iframe').join(',');

var isFocusable = function isFocusable(node, options) {
  options = options || {};

  if (!node) {
    throw new Error('No node provided');
  }

  if (matches.call(node, focusableCandidateSelector) === false) {
    return false;
  }

  return isNodeMatchingSelectorFocusable(options, node);
};


//# sourceMappingURL=index.esm.js.map

;// CONCATENATED MODULE: ./node_modules/focus-trap/dist/focus-trap.esm.js
/*!
* focus-trap 6.7.1
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var activeFocusTraps = function () {
  var trapQueue = [];
  return {
    activateTrap: function activateTrap(trap) {
      if (trapQueue.length > 0) {
        var activeTrap = trapQueue[trapQueue.length - 1];

        if (activeTrap !== trap) {
          activeTrap.pause();
        }
      }

      var trapIndex = trapQueue.indexOf(trap);

      if (trapIndex === -1) {
        trapQueue.push(trap);
      } else {
        // move this existing trap to the front of the queue
        trapQueue.splice(trapIndex, 1);
        trapQueue.push(trap);
      }
    },
    deactivateTrap: function deactivateTrap(trap) {
      var trapIndex = trapQueue.indexOf(trap);

      if (trapIndex !== -1) {
        trapQueue.splice(trapIndex, 1);
      }

      if (trapQueue.length > 0) {
        trapQueue[trapQueue.length - 1].unpause();
      }
    }
  };
}();

var isSelectableInput = function isSelectableInput(node) {
  return node.tagName && node.tagName.toLowerCase() === 'input' && typeof node.select === 'function';
};

var isEscapeEvent = function isEscapeEvent(e) {
  return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
};

var isTabEvent = function isTabEvent(e) {
  return e.key === 'Tab' || e.keyCode === 9;
};

var delay = function delay(fn) {
  return setTimeout(fn, 0);
}; // Array.find/findIndex() are not supported on IE; this replicates enough
//  of Array.findIndex() for our needs


var findIndex = function findIndex(arr, fn) {
  var idx = -1;
  arr.every(function (value, i) {
    if (fn(value)) {
      idx = i;
      return false; // break
    }

    return true; // next
  });
  return idx;
};
/**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */


var valueOrHandler = function valueOrHandler(value) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }

  return typeof value === 'function' ? value.apply(void 0, params) : value;
};

var getActualTarget = function getActualTarget(event) {
  // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
  //  shadow host. However, event.target.composedPath() will be an array of
  //  nodes "clicked" from inner-most (the actual element inside the shadow) to
  //  outer-most (the host HTML document). If we have access to composedPath(),
  //  then use its first element; otherwise, fall back to event.target (and
  //  this only works for an _open_ shadow DOM; otherwise,
  //  composedPath()[0] === event.target always).
  return event.target.shadowRoot && typeof event.composedPath === 'function' ? event.composedPath()[0] : event.target;
};

var createFocusTrap = function createFocusTrap(elements, userOptions) {
  var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;

  var config = _objectSpread2({
    returnFocusOnDeactivate: true,
    escapeDeactivates: true,
    delayInitialFocus: true
  }, userOptions);

  var state = {
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying the first and last tabbable nodes in all containers/groups in
    //  the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{ container: HTMLElement, firstTabbableNode: HTMLElement|null, lastTabbableNode: HTMLElement|null }>}
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: undefined
  };
  var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later

  var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
    return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
  };

  var containersContain = function containersContain(element) {
    return !!(element && state.containers.some(function (container) {
      return container.contains(element);
    }));
  };
  /**
   * Gets the node for the given option, which is expected to be an option that
   *  can be either a DOM node, a string that is a selector to get a node, `false`
   *  (if a node is explicitly NOT given), or a function that returns any of these
   *  values.
   * @param {string} optionName
   * @returns {undefined | false | HTMLElement | SVGElement} Returns
   *  `undefined` if the option is not specified; `false` if the option
   *  resolved to `false` (node explicitly not given); otherwise, the resolved
   *  DOM node.
   * @throws {Error} If the option is set, not `false`, and is not, or does not
   *  resolve to a node.
   */


  var getNodeForOption = function getNodeForOption(optionName) {
    var optionValue = config[optionName];

    if (typeof optionValue === 'function') {
      for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        params[_key2 - 1] = arguments[_key2];
      }

      optionValue = optionValue.apply(void 0, params);
    }

    if (!optionValue) {
      if (optionValue === undefined || optionValue === false) {
        return optionValue;
      } // else, empty string (invalid), null (invalid), 0 (invalid)


      throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
    }

    var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point

    if (typeof optionValue === 'string') {
      node = doc.querySelector(optionValue); // resolve to node, or null if fails

      if (!node) {
        throw new Error("`".concat(optionName, "` as selector refers to no known node"));
      }
    }

    return node;
  };

  var getInitialFocusNode = function getInitialFocusNode() {
    var node = getNodeForOption('initialFocus'); // false explicitly indicates we want no initialFocus at all

    if (node === false) {
      return false;
    }

    if (node === undefined) {
      // option not specified: use fallback options
      if (containersContain(doc.activeElement)) {
        node = doc.activeElement;
      } else {
        var firstTabbableGroup = state.tabbableGroups[0];
        var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode; // NOTE: `fallbackFocus` option function cannot return `false` (not supported)

        node = firstTabbableNode || getNodeForOption('fallbackFocus');
      }
    }

    if (!node) {
      throw new Error('Your focus-trap needs to have at least one focusable element');
    }

    return node;
  };

  var updateTabbableNodes = function updateTabbableNodes() {
    state.tabbableGroups = state.containers.map(function (container) {
      var tabbableNodes = tabbable(container);

      if (tabbableNodes.length > 0) {
        return {
          container: container,
          firstTabbableNode: tabbableNodes[0],
          lastTabbableNode: tabbableNodes[tabbableNodes.length - 1]
        };
      }

      return undefined;
    }).filter(function (group) {
      return !!group;
    }); // remove groups with no tabbable nodes
    // throw if no groups have tabbable nodes and we don't have a fallback focus node either

    if (state.tabbableGroups.length <= 0 && !getNodeForOption('fallbackFocus') // returning false not supported for this option
    ) {
      throw new Error('Your focus-trap must have at least one container with at least one tabbable node in it at all times');
    }
  };

  var tryFocus = function tryFocus(node) {
    if (node === false) {
      return;
    }

    if (node === doc.activeElement) {
      return;
    }

    if (!node || !node.focus) {
      tryFocus(getInitialFocusNode());
      return;
    }

    node.focus({
      preventScroll: !!config.preventScroll
    });
    state.mostRecentlyFocusedNode = node;

    if (isSelectableInput(node)) {
      node.select();
    }
  };

  var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
    var node = getNodeForOption('setReturnFocus', previousActiveElement);
    return node ? node : node === false ? false : previousActiveElement;
  }; // This needs to be done on mousedown and touchstart instead of click
  // so that it precedes the focus event.


  var checkPointerDown = function checkPointerDown(e) {
    var target = getActualTarget(e);

    if (containersContain(target)) {
      // allow the click since it ocurred inside the trap
      return;
    }

    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      // immediately deactivate the trap
      trap.deactivate({
        // if, on deactivation, we should return focus to the node originally-focused
        //  when the trap was activated (or the configured `setReturnFocus` node),
        //  then assume it's also OK to return focus to the outside node that was
        //  just clicked, causing deactivation, as long as that node is focusable;
        //  if it isn't focusable, then return focus to the original node focused
        //  on activation (or the configured `setReturnFocus` node)
        // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
        //  which will result in the outside click setting focus to the node
        //  that was clicked, whether it's focusable or not; by setting
        //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
        //  on activation (or the configured `setReturnFocus` node)
        returnFocus: config.returnFocusOnDeactivate && !isFocusable(target)
      });
      return;
    } // This is needed for mobile devices.
    // (If we'll only let `click` events through,
    // then on mobile they will be blocked anyways if `touchstart` is blocked.)


    if (valueOrHandler(config.allowOutsideClick, e)) {
      // allow the click outside the trap to take place
      return;
    } // otherwise, prevent the click


    e.preventDefault();
  }; // In case focus escapes the trap for some strange reason, pull it back in.


  var checkFocusIn = function checkFocusIn(e) {
    var target = getActualTarget(e);
    var targetContained = containersContain(target); // In Firefox when you Tab out of an iframe the Document is briefly focused.

    if (targetContained || target instanceof Document) {
      if (targetContained) {
        state.mostRecentlyFocusedNode = target;
      }
    } else {
      // escaped! pull it back in to where it just left
      e.stopImmediatePropagation();
      tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
    }
  }; // Hijack Tab events on the first and last focusable nodes of the trap,
  // in order to prevent focus from escaping. If it escapes for even a
  // moment it can end up scrolling the page and causing confusion so we
  // kind of need to capture the action at the keydown phase.


  var checkTab = function checkTab(e) {
    var target = getActualTarget(e);
    updateTabbableNodes();
    var destinationNode = null;

    if (state.tabbableGroups.length > 0) {
      // make sure the target is actually contained in a group
      // NOTE: the target may also be the container itself if it's tabbable
      //  with tabIndex='-1' and was given initial focus
      var containerIndex = findIndex(state.tabbableGroups, function (_ref) {
        var container = _ref.container;
        return container.contains(target);
      });

      if (containerIndex < 0) {
        // target not found in any group: quite possible focus has escaped the trap,
        //  so bring it back in to...
        if (e.shiftKey) {
          // ...the last node in the last group
          destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
        } else {
          // ...the first node in the first group
          destinationNode = state.tabbableGroups[0].firstTabbableNode;
        }
      } else if (e.shiftKey) {
        // REVERSE
        // is the target the first tabbable node in a group?
        var startOfGroupIndex = findIndex(state.tabbableGroups, function (_ref2) {
          var firstTabbableNode = _ref2.firstTabbableNode;
          return target === firstTabbableNode;
        });

        if (startOfGroupIndex < 0 && state.tabbableGroups[containerIndex].container === target) {
          // an exception case where the target is the container itself, in which
          //  case, we should handle shift+tab as if focus were on the container's
          //  first tabbable node, and go to the last tabbable node of the LAST group
          startOfGroupIndex = containerIndex;
        }

        if (startOfGroupIndex >= 0) {
          // YES: then shift+tab should go to the last tabbable node in the
          //  previous group (and wrap around to the last tabbable node of
          //  the LAST group if it's the first tabbable node of the FIRST group)
          var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
          var destinationGroup = state.tabbableGroups[destinationGroupIndex];
          destinationNode = destinationGroup.lastTabbableNode;
        }
      } else {
        // FORWARD
        // is the target the last tabbable node in a group?
        var lastOfGroupIndex = findIndex(state.tabbableGroups, function (_ref3) {
          var lastTabbableNode = _ref3.lastTabbableNode;
          return target === lastTabbableNode;
        });

        if (lastOfGroupIndex < 0 && state.tabbableGroups[containerIndex].container === target) {
          // an exception case where the target is the container itself, in which
          //  case, we should handle tab as if focus were on the container's
          //  last tabbable node, and go to the first tabbable node of the FIRST group
          lastOfGroupIndex = containerIndex;
        }

        if (lastOfGroupIndex >= 0) {
          // YES: then tab should go to the first tabbable node in the next
          //  group (and wrap around to the first tabbable node of the FIRST
          //  group if it's the last tabbable node of the LAST group)
          var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;

          var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
          destinationNode = _destinationGroup.firstTabbableNode;
        }
      }
    } else {
      // NOTE: the fallbackFocus option does not support returning false to opt-out
      destinationNode = getNodeForOption('fallbackFocus');
    }

    if (destinationNode) {
      e.preventDefault();
      tryFocus(destinationNode);
    } // else, let the browser take care of [shift+]tab and move the focus

  };

  var checkKey = function checkKey(e) {
    if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
      e.preventDefault();
      trap.deactivate();
      return;
    }

    if (isTabEvent(e)) {
      checkTab(e);
      return;
    }
  };

  var checkClick = function checkClick(e) {
    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      return;
    }

    var target = getActualTarget(e);

    if (containersContain(target)) {
      return;
    }

    if (valueOrHandler(config.allowOutsideClick, e)) {
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();
  }; //
  // EVENT LISTENERS
  //


  var addListeners = function addListeners() {
    if (!state.active) {
      return;
    } // There can be only one listening focus trap at a time


    activeFocusTraps.activateTrap(trap); // Delay ensures that the focused element doesn't capture the event
    // that caused the focus trap activation.

    state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function () {
      tryFocus(getInitialFocusNode());
    }) : tryFocus(getInitialFocusNode());
    doc.addEventListener('focusin', checkFocusIn, true);
    doc.addEventListener('mousedown', checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener('touchstart', checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener('click', checkClick, {
      capture: true,
      passive: false
    });
    doc.addEventListener('keydown', checkKey, {
      capture: true,
      passive: false
    });
    return trap;
  };

  var removeListeners = function removeListeners() {
    if (!state.active) {
      return;
    }

    doc.removeEventListener('focusin', checkFocusIn, true);
    doc.removeEventListener('mousedown', checkPointerDown, true);
    doc.removeEventListener('touchstart', checkPointerDown, true);
    doc.removeEventListener('click', checkClick, true);
    doc.removeEventListener('keydown', checkKey, true);
    return trap;
  }; //
  // TRAP DEFINITION
  //


  trap = {
    activate: function activate(activateOptions) {
      if (state.active) {
        return this;
      }

      var onActivate = getOption(activateOptions, 'onActivate');
      var onPostActivate = getOption(activateOptions, 'onPostActivate');
      var checkCanFocusTrap = getOption(activateOptions, 'checkCanFocusTrap');

      if (!checkCanFocusTrap) {
        updateTabbableNodes();
      }

      state.active = true;
      state.paused = false;
      state.nodeFocusedBeforeActivation = doc.activeElement;

      if (onActivate) {
        onActivate();
      }

      var finishActivation = function finishActivation() {
        if (checkCanFocusTrap) {
          updateTabbableNodes();
        }

        addListeners();

        if (onPostActivate) {
          onPostActivate();
        }
      };

      if (checkCanFocusTrap) {
        checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
        return this;
      }

      finishActivation();
      return this;
    },
    deactivate: function deactivate(deactivateOptions) {
      if (!state.active) {
        return this;
      }

      clearTimeout(state.delayInitialFocusTimer); // noop if undefined

      state.delayInitialFocusTimer = undefined;
      removeListeners();
      state.active = false;
      state.paused = false;
      activeFocusTraps.deactivateTrap(trap);
      var onDeactivate = getOption(deactivateOptions, 'onDeactivate');
      var onPostDeactivate = getOption(deactivateOptions, 'onPostDeactivate');
      var checkCanReturnFocus = getOption(deactivateOptions, 'checkCanReturnFocus');

      if (onDeactivate) {
        onDeactivate();
      }

      var returnFocus = getOption(deactivateOptions, 'returnFocus', 'returnFocusOnDeactivate');

      var finishDeactivation = function finishDeactivation() {
        delay(function () {
          if (returnFocus) {
            tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
          }

          if (onPostDeactivate) {
            onPostDeactivate();
          }
        });
      };

      if (returnFocus && checkCanReturnFocus) {
        checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
        return this;
      }

      finishDeactivation();
      return this;
    },
    pause: function pause() {
      if (state.paused || !state.active) {
        return this;
      }

      state.paused = true;
      removeListeners();
      return this;
    },
    unpause: function unpause() {
      if (!state.paused || !state.active) {
        return this;
      }

      state.paused = false;
      updateTabbableNodes();
      addListeners();
      return this;
    },
    updateContainerElements: function updateContainerElements(containerElements) {
      var elementsAsArray = [].concat(containerElements).filter(Boolean);
      state.containers = elementsAsArray.map(function (element) {
        return typeof element === 'string' ? doc.querySelector(element) : element;
      });

      if (state.active) {
        updateTabbableNodes();
      }

      return this;
    }
  }; // initialize container elements

  trap.updateContainerElements(elements);
  return trap;
};


//# sourceMappingURL=focus-trap.esm.js.map

;// CONCATENATED MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
/*! js-cookie v3.0.1 | MIT */
/* eslint-disable no-var */
function js_cookie_assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (key, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = js_cookie_assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    key = encodeURIComponent(key)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      key + '=' + converter.write(value, key) + stringifiedAttributes)
  }

  function get (key) {
    if (typeof document === 'undefined' || (arguments.length && !key)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);

        if (key === foundKey) {
          break
        }
      } catch (e) {}
    }

    return key ? jar[key] : jar
  }

  return Object.create(
    {
      set: set,
      get: get,
      remove: function (key, attributes) {
        set(
          key,
          '',
          js_cookie_assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, js_cookie_assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(js_cookie_assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */

/* harmony default export */ const js_cookie = (api);

;// CONCATENATED MODULE: ./src/css/main.css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/js/main.js






/**
 * Promotional Section
 */
class PromoSection extends HTMLElement {
  constructor() {
    super();
    
    this.sticky = JSON.parse(this.dataset.sticky);
    this.announcementBars = this.querySelectorAll('[data-block-type="announcement-bar"]');

    if (this.announcementBars.length > 0) {
      this.initAnnoucementBars();
    }

    if (this.sticky) {
      this.setResizeObserver();
    }

    this.bindEvents();
  }

  setResizeObserver() {
    // create and dispatch the event
    const event = new CustomEvent('stickyResize', {
      detail: {
        element: this,
      },
    });

    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const cr = entry.contentRect;
        const top = cr.height + cr.top;
        document.documentElement.style.setProperty(
          '--section-header-top-offset',
          `${top}px`
        );
        window.dispatchEvent(new CustomEvent('stickyResize', {
          detail: {
            element: this,
            top: top,
          }
        }));
      }
    });

    resizeObserver.observe(this);
  }

  initAnnoucementBars() {
    this.announcementBars.forEach((bar) => {
      const hideDelay = JSON.parse(bar.dataset.hideDelay);
      if (!hideDelay || Shopify.designMode) return;

      setTimeout(() => {
        hide(bar, {
          miliseconds: 300,
          transitionFunction: 'ease-out',
        });
      }, hideDelay);

    });
  }

  bindEvents() {
    const signupBars = this.querySelectorAll('[data-block-type="signup-bar"]');
    if (signupBars.length > 0) {
      signupBars.forEach((bar) => {
        const blockType = bar.dataset.blockType;
        const blockId = bar.dataset.blockId;
        const button = bar.querySelector('.signup-bar__close');
        const form = bar.querySelector('form');
        const showFor = bar.dataset.showFor;

        const showDelay = bar.dataset.delay;

        if (Shopify.designMode) {
          return;
        }

        // Uncomment to test 
        // Cookies.remove(`${blockType}-${blockId}`);

        // Show if Cookie doesn't exist
        if (js_cookie.get(`${blockType}-${blockId}`) === undefined) {
          setTimeout(() => {
            if (
              showFor === 'desktop' &&
              window.innerWidth < theme.mobileBreakpoint
            ) {
              return;
            }
            if (
              showFor === 'mobile' &&
              window.innerWidth >= theme.mobileBreakpoint
            ) {
              return;
            }

            toggle(bar, {
              miliseconds: 300,
              transitionFunction: 'ease-out',
            });
          }, showDelay);
        }

        button.addEventListener('click', (event) => {
          toggle(bar, {
            miliseconds: 300,
            transitionFunction: 'ease-out',
          });

          const expireDays = 60;
          js_cookie.set(`${blockType}-${blockId}`, 'close', {
            expires: expireDays,
          });

          event.preventDefault();
        });

        form.addEventListener('submit', (event) => {
          toggle(bar, {
            miliseconds: 300,
            transitionFunction: 'ease-out',
          });

          const expireDays = 365;
          js_cookie.set(`${blockType}-${blockId}`, 'submit', {
            expires: expireDays,
          });
        });
      });
    }


    if (Shopify.designMode) {
      document.addEventListener('shopify:block:select', (event) => {
        const blockId = event.detail.blockId;
        const selectedBlock = this.querySelector(
          `[data-block-id="${blockId}"]`
        );
        if (!selectedBlock) return;

        if (selectedBlock.dataset.blockType === 'signup-bar') { 
          show(selectedBlock, {
            miliseconds: 300,
            transitionFunction: 'ease-out',
          });
        }

        if (selectedBlock.dataset.blockType === 'popup') {
          selectedBlock.showModal();
        }
      });

      document.addEventListener('shopify:block:deselect', (event) => {
        const blockId = event.detail.blockId;
        const selectedBlock = this.querySelector(
          `[data-block-id="${blockId}"]`
        );
        if (!selectedBlock) return;

        if (selectedBlock.dataset.blockType === 'signup-bar') {
          hide(selectedBlock, {
            miliseconds: 300,
            transitionFunction: 'ease-out',
          });
        }

        if (selectedBlock.dataset.blockType === 'popup') {
          selectedBlock.hideModal();
        }
      });
    }
    
  }
}
customElements.define('promo-section', PromoSection);

class PopupModal extends HTMLElement {
  constructor() {
    super();

    this.originalZIndex = 500;
    this.openZIndex = 1000;
    this.promoSection = this.closest('.section__promos');
    this.blockType = this.dataset.blockType;
    this.blockId = this.dataset.blockId;

    this.focusTrap = createFocusTrap(this, {
      initialFocus: false,
    });

    this.delay = this.dataset.delay;
    // True - only show to theme.pageType == index
    this.homepageLimit = JSON.parse(this.dataset.homepageLimit);
    // True - only show to theme.customers / False show to everyone
    this.visitorLimit = JSON.parse(this.dataset.visitorLimit);
    // mobile, desktop, both
    this.showFor = this.dataset.showFor;

    // Qualify if popup should be show
    if (Shopify.designMode) {
      return;
    }

    // Uncomment to test
    // Cookies.remove(`${this.blockType}-${this.blockId}`);
    
    // Don't show if cookied
    if (js_cookie.get(`${this.blockType}-${this.blockId}`) !== undefined) {
      return;
    }

    if (this.homepageLimit == true && theme.pageType !== 'index') {
      return;
    }

    if (this.visitorLimit == true && theme.customer) {
      return;
    }

    setTimeout(() => {
      if (
        this.showFor === 'desktop' &&
        window.innerWidth < theme.mobileBreakpoint
      ) {
        return;
      }
      if (
        this.showFor === 'mobile' &&
        window.innerWidth >= theme.mobileBreakpoint
      ) {
        return;
      }

      this.bindEvents();
      this.showModal();
    }, this.delay);
  }

  bindEvents() {
    this.closeButton = this.querySelector('.modal__close');
    this.modalBackground = this.querySelector('.modal__background');
    this.form = this.querySelector('form');

    this.closeButton.addEventListener('click', (event) => {
      event.preventDefault();
      this.hideModal();

      const expireDays = 60;
      js_cookie.set(`${this.blockType}-${this.blockId}`, 'close', {
        expires: expireDays,
      });
    });

    this.modalBackground.addEventListener('click', (event) => {
      event.preventDefault();
      this.hideModal();

      const expireDays = 60;
      js_cookie.set(`${this.blockType}-${this.blockId}`, 'close', {
        expires: expireDays,
      });
    });

    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hideModal();

      const expireDays = 60;
      js_cookie.set(`${this.blockType}-${this.blockId}`, 'close', {
        expires: expireDays,
      });
    });

    this.form.addEventListener('submit', (event) => {
      const expireDays = 365;
      js_cookie.set(`${this.blockType}-${this.blockId}`, 'submit', {
        expires: expireDays,
      });
    });
  }

  showModal() {
    document.body.classList.add('has-modal');
    this.promoSection.style.zIndex = this.openZIndex;
    this.classList.add('modal--active');
    this.closeButton = this.querySelector('.modal__close');
    this.closeButton.focus();

    this.focusTrap.activate();
  }

  hideModal() {
    document.body.classList.remove('has-modal');
    this.classList.remove('modal--active');

    this.focusTrap.deactivate();
  }
}
customElements.define('popup-modal', PopupModal);

/**
 * Top Header
 */
class HeaderTop extends HTMLElement {
  constructor() {
    super();

    this.SearchBar = this.querySelector('search-bar');
    this.searchBarButton = this.querySelector('.header-top__search');
    this.searchBarContainer = this.querySelector('.header-top__search-bar');

    this.menuButton = this.querySelector('.header-top__menu');
    this.menuDrawer = this.querySelector('menu-drawer');
    this.modalBackground = this.querySelector('.modal__background');
    this.modalClose = this.querySelector('.modal__close');

    this.headerTop = this.querySelector('.header-top');
    this.sticky = JSON.parse(this.headerTop.dataset.sticky);

    this.focusTrap = createFocusTrap(this.menuDrawer, {
      initialFocus: false,
    });

    if (this.sticky) {
      this.setResizeObserver();
    }

    this.bindEvents();
  }

  bindEvents() {
    this.searchBarButton.addEventListener('click', (event) =>
      this.openSearchBar(event)
    );
    this.menuButton.addEventListener('click', (event) => this.openMenu(event) );

    this.modalBackground.addEventListener('click', (event) =>
      this.closeMenu(event)
    );
    this.modalClose.addEventListener('click', (event) => this.closeMenu(event));
    this.addEventListener('keyup', (event) => this.menuKeyUp(event));
  }

  setResizeObserver() {
    // triggered from promotional section
    window.addEventListener('stickyResize', (event) => { 
      // promo section + this height + this top
      const top = event.detail.top + this.offsetHeight + this.offsetTop;
      document.documentElement.style.setProperty(
        '--section-header-offset',
        `${top}px`
      );
    });
    
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const cr = entry.contentRect;
        let top = cr.height + cr.top;

        const headerTopOffsetPx =
          document.documentElement.style.getPropertyValue(
            '--section-header-top-offset'
          );

        if (headerTopOffsetPx) {
          top = top + Number(headerTopOffsetPx.replace(/[^0-9\.]+/g, ''));
        }
        
        document.documentElement.style.setProperty(
          '--section-header-offset',
          `${top}px`
        );
      }
    });

    resizeObserver.observe(this);
  }

  openMenu(event) { 
    event.preventDefault();

    this.menuButton.setAttribute('aria-expanded', true);
    this.menuDrawer.setAttribute('open', true);
    document.body.classList.add('has-modal');

    this.focusTrap.activate();
  }

  menuKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    this.closeMenu(event);
  }

  closeMenu(event) {
    event.preventDefault();

    this.menuButton.setAttribute('aria-expanded', false);
    this.menuDrawer.removeAttribute('open');
    document.body.classList.remove('has-modal');

    this.focusTrap.deactivate();
  }

  openSearchBar(event) {
    event.preventDefault();

    toggle(this.searchBarContainer, {
      miliseconds: 300,
      transitionFunction: 'ease-out',
      onAnimationEnd: () => {
        this.searchBarButton.setAttribute(
          'aria-expanded',
          (
            this.searchBarButton.getAttribute('aria-expanded') === 'false'
          ).toString()
        );
        if (this.searchBarButton.getAttribute('aria-expanded') === 'true') {
          this.SearchBar.activateExpand();
        }
      },
    });
  }

  closeSearchBar(options = {refocus: false}) {
    hide(this.searchBarContainer, {
      miliseconds: 300,
      transitionFunction: 'ease-out',
      onAnimationEnd: () => {
        this.searchBarButton.setAttribute('aria-expanded', 'false');
        this.searchBarContainer.setAttribute('hidden', true);
        if (options.refocus) {
          this.searchBarButton.focus();
        }
      },
    });
  }
}
customElements.define('header-top-section', HeaderTop);

class SearchBar extends HTMLElement {
  constructor() {
    super();

    this.searchInput = this.querySelector('.search__input');
    this.closeButton = this.querySelector('.search-bar__close');
    this.HeaderTop = this.closest('header-top-section');

    if (this.closeButton) {
      this.closeButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.HeaderTop.closeSearchBar({
          refocus: true,
        });
      });
    }

    this.addEventListener('keyup', (event) => this.expandKeyUp(event));
    this.addEventListener('focusout', (event) => this.expandFocusOut(event));
  }

  activateExpand() {
    this.searchInput.focus();
    
  }

  expandFocusOut(event) {
    if (event.relatedTarget === null || !this.contains(event.relatedTarget)) {
      this.HeaderTop.closeSearchBar();
    }
  }


  expandKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.HeaderTop.closeSearchBar({
      refocus: true,
    });
  }
}
customElements.define('search-bar', SearchBar);



/**
 * Disclosure Localization
 */
class DisclosureItem extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('button');
    this.panel = this.querySelector('ul.disclosure__list');

    this.button.addEventListener('click', (event) => this.openPanel(event));
    this.addEventListener('focusout', (event) => this.panelFocusCheck(event));
    this.addEventListener('keyup', (event) => this.panelKeyUp(event));
  }

  openPanel(event) {
    event.preventDefault();
    this.button.focus();
    this.panel.toggleAttribute('hidden');
    this.button.setAttribute(
      'aria-expanded',
      (this.button.getAttribute('aria-expanded') === 'false').toString()
    );
  }

  panelFocusCheck(event) {
    if (event.relatedTarget === null || !this.contains(event.relatedTarget)) {
      this.hidePanel();
    }
  }

  panelKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.button.focus();
  }

  hidePanel() {
    this.button.setAttribute('aria-expanded', 'false');
    this.panel.setAttribute('hidden', true);
  }
}
customElements.define('disclosure-item', DisclosureItem);

class DisclosureForm extends DisclosureItem {
  constructor() {
    super();

    this.input = this.querySelector(
      'input[name="locale_code"], input[name="country_code"]'
    );
    this.form = this.querySelector('form');
    this.querySelectorAll('a').forEach((item) =>
      item.addEventListener('click', (event) => this.onItemClick(event))
    );
  }

  onItemClick(event) {
    event.preventDefault();
    this.input.value = event.currentTarget.dataset.value;
    if (this.form) {
      this.form.submit();
    }
  }
}
customElements.define('disclosure-form', DisclosureForm);

class DisclosureMenu extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector('details');
    this.detailsChildren = this.querySelectorAll(
      'details .list-menu:not([data-mega-menu]) details'
    );
    this.summary = this.querySelector('summary');

    this.details.addEventListener('click', (event) => this.onOpenPanel(event));
    this.addEventListener('keyup', (event) => this.panelKeyUp(event));
    
    if (this.details.classList.contains('header-menu__details')) {
      this.addEventListener('focusout', (event) => this.panelFocusCheck(event));
      this.addEventListener('mouseenter', (event) => this.panelMouseEnter(event));
      this.addEventListener('mouseleave', (event) => this.panelMouseLeave(event));
    }

    this.nav = this.closest('nav');
  }

  onOpenPanel(event) {
    const currentDetails = event.target.closest('details');
    this.detailsChildren.forEach((item) => {
      if (item == currentDetails) return;
      this.hidePanel(item);
    });

    if (this.nav) {
      const drawerSiblingDetails = this.nav.querySelectorAll(
        'details.drawer-menu__details'
      );
      drawerSiblingDetails.forEach((item) => {
        if (
          item === currentDetails ||
          currentDetails.classList.contains('drawer-menu__details-child')
        )
          return;

        this.hidePanel(item);
      });

      const autoClosingDetails = this.nav.querySelectorAll(
        'details.footer-menu__details, details.menu__details'
      );
      autoClosingDetails.forEach((item) => {
        if (
          item === currentDetails ||
          currentDetails.classList.contains('footer-menu__details-child') ||
          currentDetails.classList.contains('menu__details-child')
        )
          return;

        this.hidePanel(item);
      });
    }

    if (event.type === 'click' && event.detail > 0) {
      if (
        event.pointerType === 'mouse' &&
        currentDetails.classList.contains('header-menu__details')
      ) {
        window.location.href = currentDetails.dataset.link;
      }
    }
  }

  panelMouseEnter(event) {
    this.openPanel(this.details);
    this.onOpenPanel(event);

  }
  panelMouseLeave(event) {
    this.hidePanel(this.details);
  }

  panelFocusCheck(event) {
    if (event.relatedTarget === null || !this.contains(event.relatedTarget)) {
      this.hidePanel(this.details);
    }
  }
 
  panelKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    const closestDetails = document.activeElement.closest('details');
    const closestSummary = closestDetails.querySelector('summary');

    this.hidePanel(closestDetails);
    closestSummary.focus();
  }

  openPanel(details) {
    details.setAttribute('open', true);
  }

  hidePanel(details) {
    details.removeAttribute('open');
  }
}
customElements.define('disclosure-menu', DisclosureMenu);

/**
 * Swatch - Radios
 */
class SwatchRadios extends HTMLElement {
  constructor() {
    super();

    this.productCard = this.closest('.product-card');
    this.productMedia = this.productCard.querySelector('.product-card__media');
    this.productImage = this.productCard.querySelector(
      '.product-card__featured-image'
    );
    this.productLink = this.productCard.previousElementSibling;

    this.addEventListener('change', this.onSwatchChange);
  }

  onSwatchChange(event) {
    this.selected = event.target;
    this.selectedVariantUrl = this.selected.dataset.variantUrl;
    this.selectedVariantImage = this.selected.dataset.variantImage;

    if (this.selectedVariantImage) {
      this.updateImage();
    }
    this.updateLinks();
  }

  updateImage() {
    this.productImage.src = this.selectedVariantImage;
    this.productImage.srcset = '';
    this.productImage.sizes = '';
  }

  updateLinks() {
    this.productMedia.href = this.selectedVariantUrl;
    this.productLink.href = this.selectedVariantUrl;
  }
}
customElements.define('swatch-radios', SwatchRadios);

/**
 * Quantity Select
 */
class QuantitySelect extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('.quantity__input');
    this.minus = this.querySelector('.quantity__button[name="minus"]');
    this.plus = this.querySelector('.quantity__button[name="plus"]');

    this.changeEvent = new Event('change', {bubbles: true});

    this.minus.addEventListener('click', (event) => {
      this.decreaseQuantity();
    });
    this.plus.addEventListener('click', (event) => {
      this.increaseQuantity();
    });
  }

  decreaseQuantity(event) {
    const previousValue = this.input.value;

    if (Number(this.input.value) == 1) return;
    this.input.value = Number(this.input.value) - 1;
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  increaseQuantity(event) {
    const previousValue = this.input.value;

    this.input.value = Number(this.input.value) + 1;
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define('quantity-select', QuantitySelect);

class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.cartButton = document.getElementById('cart-button');
    this.notification = document.getElementById('cart-notification');
    this.continueButton = this.querySelector('.cart-notification__continue');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.focusTrap = createFocusTrap(this.notification, {
      allowOutsideClick: true,
    });
    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.close();
    });

    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', (event) => {
        this.close();
      })
    );
  }

  open() {
    this.notification.classList.add('cart-notification--active');
    this.notification.focus();
    this.focusTrap.activate();
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('cart-notification--active');
    document.body.removeEventListener('click', this.onBodyClick);
    this.focusTrap.deactivate();
    this.activeElement.focus();
  }

  handleBodyClick(event) {
    const target = event.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-links',
      },
      {
        id: 'cart-button',
      },
    ];
  }

  renderContents(response) {
    this.productId = response.id;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        response.sections[section.id],
        section.selector
      );
    });

    this.open();
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}
customElements.define('cart-notification', CartNotification);

/*
* Theme Common JS
*/

/**
 * Delay Javascript until user interaction
 * Sections will lazyload when in view, but some should wait until it is in view 
 * and the user has interacted with the page.
 */

theme.userInteraction = false;
const userInteractionEvents = ['mouseover', 'keydown', 'scroll', 'touchstart'];

document.addEventListener('DOMContentLoaded', () => {
  userInteractionEvents.forEach((eventName) => {
    document.addEventListener(eventName, onUserInteraction, {
      passive: true
    });
  });
});


function onUserInteraction() {
  theme.userInteraction = true;

  userInteractionEvents.forEach((event) => {
    document.removeEventListener(event, onUserInteraction, {
      passive: true
    });
  });
};

theme.debounce = (fn, wait) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(undefined, args), wait);
  };
}

theme.fetchConfig = (type = 'json') => {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

theme.pauseAllMedia = () => {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*'
    );
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

/******/ })()
;

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}